<script>
  import { afterUpdate, onMount } from "svelte"
  export let index
  export let innerActive
  export let key
  export let value
  /**
   * @type {Boolean} whether to show the inner row or not
   */
  let hideInnerContent = false

  onMount(() => {
    hideInnerContent = index == innerActive
  })
  afterUpdate(() => {
    hideInnerContent = index == innerActive
  })
</script>

<!-- svelte-ignore a11y-click-events-have-key-events -->
<div
  on:click={() => {
    if (!hideInnerContent) innerActive = index
    else innerActive = undefined
    hideInnerContent = !hideInnerContent
  }}
  class="flex h-full {hideInnerContent ? 'bg-red-500 text-white' : 'bg-[#f7f7f7] text-gray-700 dark:bg-bodyblack dark:text-gray-200'} w-full cursor-pointer items-center justify-between rounded-md px-3 py-2 text-center text-base font-bold"
>
  <!-- <div
  on:click={() => {
    if (!hideInnerContent) innerActive = index
    else innerActive = undefined
    hideInnerContent = !hideInnerContent
  }}
  class="flex h-full {hideInnerContent ? 'bg-[#f8d7da] text-[#ff0c0c]' : 'bg-[#f7f7f7] text-gray-700'} w-full cursor-pointer items-center justify-between rounded-md px-3 py-2 text-center text-base font-bold"
> -->
  <h1>{key}</h1>
  <span>
    <i class="fa-solid {hideInnerContent ? 'fa-chevron-up' : 'fa-chevron-down'} " />
  </span>
</div>
{#if hideInnerContent}
  <div class="flex h-full w-full flex-col gap-1 rounded-md border border-[#ff0c0c] px-3 py-2 text-sm font-bold text-red-500">
    {#each value as value}
      <h1>{@html value}</h1>
    {/each}
  </div>
{/if}
